import type { ColumnFilterOptionItem } from '@/lib/table/types';

// The vehicle list's URL/API contract: which column ids a stored view may
// reference and which sort keys the backend accepts. Presentation (cell
// renderers, filter wiring) lives in ../components/columns.tsx instead.
export const VEHICLE_SORT_KEYS: readonly string[] = [
  'licensePlate',
  'brand',
  'model',
  'status',
  'location',
  'currentDriver',
  'mileageMeters',
  'drivetrain',
  'modelType',
  'vehicleAgeYears',
  'firstRegistration',
  'co2CombinedMgKm',
  // Every other master-data field (manage-vehicles-04/05), the PRD's
  // "every master-data field" row: searchable/sortable, never filterable.
  'countryCode',
  'vin',
  'transmission',
  'hsn',
  'tsn',
  'bodyType',
  'doors',
  'seats',
  'vehicleClass',
  'driveLayout',
  'systemPowerWatts',
  'enginePowerWatts',
  'displacementCm3',
  'acChargingPort',
  'maxAcChargingPowerWatts',
  'dcChargingPort',
  'maxDcChargingPowerWatts',
  'testCycle',
  'emissionClass',
  'depletedBatteryConsumptionMl',
  'allElectricConsumptionWh',
  'electricRangeMeters',
  'adBlueTankMl',
  'lengthMinMm',
  'lengthMaxMm',
  'widthWithoutMirrorsMinMm',
  'widthWithoutMirrorsMaxMm',
  'widthIncludingMirrorsMm',
  'heightMinMm',
  'heightMaxMm',
  'kerbWeightMinGrams',
  'kerbWeightMaxGrams',
  'grossMassGrams',
  'towingCapacityBrakedGrams',
  'towingCapacityUnbrakedGrams',
  'grossCombinationMassGrams',
  'noseWeightGrams',
  'roofLoadGrams',
  'bootNormalMl',
  'bootMaxMl',
  'frunkMl',
];

export const VEHICLE_COLUMN_IDS: readonly string[] = [
  'imageUrl',
  ...VEHICLE_SORT_KEYS,
  // Not sortable (dates — the facade's generic `compareValues` has no branch
  // for them beyond the two explicitly-sortable date fields above) but still
  // offered as opt-in columns.
  'productionDate',
  'mileageRecordedOn',
  // Non-sortable opt-in columns (booleans + the derived payload pair).
  'heatPump',
  'adBlueSystemPresent',
  'payloadMinGrams',
  'payloadMaxGrams',
  // The trailing chevron — not itself hideable, but a known id so a stored
  // view referencing it (there is none today) can't be mistaken for drift.
  'chevron',
];

// The filter option lists, loaded from the API by the route — the PRD's
// exactly-six multi-select filters (Brand, Model, Model type, Status,
// Location, Drivetrain). None are static: access/tenant-scoped, narrowed live.
export interface VehicleFilterOptions {
  brand: ColumnFilterOptionItem[];
  model: ColumnFilterOptionItem[];
  modelType: ColumnFilterOptionItem[];
  status: ColumnFilterOptionItem[];
  location: ColumnFilterOptionItem[];
  drivetrain: ColumnFilterOptionItem[];
}
